import { Accordion, Container } from "@mantine/core";
import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { GiPriceTag } from "react-icons/gi";
import { RiCustomerServiceLine } from "react-icons/ri";
import { imageCodes } from "../../template_codes/asteria/home_page_codes";

const Reasons = () => {
  return (
    <div className="pt-10">
      <h1 className="text-sm md:text-3xl text-[#D8AE96] uppercase text-center">
        Reasons Why People Choose Us Always
      </h1>
      <Container size={"sm"} mt={"sm"}>
        <Accordion defaultValue="test">
          <Accordion.Item value="customization">
            <Accordion.Control>
              <div className="flex items-end gap-2">
                <img src={imageCodes.hanger.image} width={20} height={5}></img>
                <p className="text-sm">Minimal & Stylish Design</p>
              </div>
            </Accordion.Control>
            <Accordion.Panel>
              <p className="text-gray-500  text-sm tracking-wider">
                We keep our customers stay on today's fashion trend. We make
                sure our customers feel confident with Asteria.
              </p>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item value="flexibility">
            <Accordion.Control>
              <div className="flex items-end gap-2">
                {/* <img src={imageCodes.hanger.image} width={20} height={5}></img> */}
                <GiPriceTag className="text-gray-500" />
                <p className="text-sm">Affordable Price</p>
              </div>
            </Accordion.Control>
            <Accordion.Panel>
              <p className="text-gray-500  text-sm tracking-wider">
                Expensive does not mean classy. We give you best quality designs
                in affordable price.
              </p>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item value="focus-ring">
            <Accordion.Control>
              <div className="flex items-end gap-2">
                {/* <img src={imageCodes.hanger.image} width={20} height={5}></img> */}
                <RiCustomerServiceLine className="text-gray-500" />
                <p className="text-sm">Customer Care</p>
              </div>
            </Accordion.Control>
            <Accordion.Panel>
              <p className="text-gray-500  text-sm tracking-wider">
                We care you with heart and make you feel as home.
              </p>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
        <div className="mt-10 flex gap-5 items-center">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/df-kirin.appspot.com/o/pos%2F1638333769519e3464a8aa721ea12c579d1c1d61971ba?alt=media&token=9d7ca05c-b353-4c3e-a0f9-9c67a39cf72d"
            alt=""
            className="h-96 rounded-xl shadow-xl hidden md:block"
          />
          <div className="border md:border-none p-5 md:p-0 rounded-xl shadow-lg md:shadow-none">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/df-kirin.appspot.com/o/pos%2F1638333769519e3464a8aa721ea12c579d1c1d61971ba?alt=media&token=9d7ca05c-b353-4c3e-a0f9-9c67a39cf72d"
              alt=""
              className="w-20 h-20 object-cover object-center rounded-full mx-auto mb-5 block md:hidden"
            />
            <p className="text-md md:text-xl font-extralight leading-6">
              Our only intention is to give every girls excitement and happiness
              while wearing our designs, because happiest girls are the
              prettiest.
            </p>
            <p className="text-sm mt-5 font-semibold float-right">
              Co. Founder, Tina Aung
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Reasons;
